import type { TippyProps } from '@tippyjs/react/headless';
import Tippy from '@tippyjs/react/headless';

import { classNames } from '@/utils';

import type { TooltipPlacement, TooltipProps } from './types';

import { TOOLTIP_STYLE } from '@/components/base/Tooltip/styles';

import Arrow from './Arrow';

type TippyTooltipProps = TooltipProps & Omit<TippyProps, keyof TooltipProps>;

export const TooltipTippy = ({
    children,
    content,
    position = 'bottom',
    arrow = true,
    variant = 'default',
    arrowVariant = 'default',
    tooltipAdditionalClasses,
    ...restProps
}: TippyTooltipProps) => {
    return (
        <Tippy
            placement={position}
            render={(attrs) => {
                if (!content) return null;

                return (
                    <div
                        className={classNames(TOOLTIP_STYLE[variant], tooltipAdditionalClasses)}
                        {...attrs}>
                        {content}
                        {arrow ? (
                            <Arrow
                                variant={arrowVariant}
                                position={attrs['data-placement'] as TooltipPlacement}
                            />
                        ) : null}
                    </div>
                );
            }}
            {...restProps}>
            {children}
        </Tippy>
    );
};
